import { useNavigate } from 'react-router-dom'

export default function NotFound() {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 py-24">
      <h1 className="text-7xl font-extrabold text-primary-600 mb-4">404</h1>
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Página no encontrada</h2>
      <p className="text-gray-600 mb-6 text-center max-w-md">
        Lo sentimos, la página que buscas no existe o fue movida. Por favor, verifica la URL o vuelve al inicio.
      </p>
      <button
        onClick={() => navigate('/', { replace: true })}
        className="rounded-full bg-primary-600 px-6 py-2 text-white font-semibold shadow hover:bg-primary-500 transition-colors"
      >
        Volver al inicio
      </button>
    </div>
  )
} 